import { useOktaAuth } from '@okta/okta-react';
import { useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { Box, Container, Heading } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const Error = () => {
  const { t } = useTranslation();
  const { authState, oktaAuth } = useOktaAuth();
  const [errorDetail, setErrorDetail] = useState(t("default_error_detail"));

  const location = useLocation();

  useEffect(() => {
  }, [authState, oktaAuth]); // Update if authState changes

  console.log(location.state);
  
  return (
    <Container>
      <Heading as="h1" size="2xl" mb={2}>{t("Identity Verification Failed")}</Heading>
      <Box p={6} borderWidth="1px" borderRadius="lg" bg="white" shadow="sm">
        <Heading 
          as="h2"
          size="md"
          mb={3}
        >
          {t(location.state?.errorMessage || 'Unknown error')}
        </Heading>
        <Box as="p">
          {(location.state?.errorDetails === undefined) ? errorDetail : t(location.state.errorDetails)}
        </Box>
      </Box>
    </Container>
  );
};
export default Error;